// Slider.js
import React from 'react';

const Slider = ({ timeStepCount, sliderValue, handleSliderChange, handleStepChange, worstColor }) => {
  return (
    <>
      <input
        type="range"
        min="0"
        max={timeStepCount - 1}
        value={sliderValue}
        onChange={handleSliderChange}
        style={{ ...styles.slider, accentColor: worstColor }}
      />
      <div style={styles.arrowContainer}>
        <button onClick={() => handleStepChange('left')} style={styles.arrowButton}>&#9664;</button>
        <button onClick={() => handleStepChange('right')} style={styles.arrowButton}>&#9654;</button>
      </div>
    </>
  );
};

const styles = {
  slider: {
    width: '90%',
    marginTop: '10px',
    height: '8px',
    borderRadius: '5px',
  },
  arrowContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
  },
  arrowButton: {
    padding: '5px 15px',
    fontSize: '24px',
    cursor: 'pointer',
    background: 'none',
    border: '1px solid black',
    borderRadius: '5px',
  },
};

export default Slider;